import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminLayout from '@/components/layout/AdminLayout';
import CareDashboard from '@/components/CareDashboard';
import { useAuth, API } from '@/App';
import axios from 'axios';

export default function CareTeamDashboardView() {
  const { subscriberId } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [subName, setSubName] = useState('');

  useEffect(() => {
    if (subscriberId) {
      axios.get(`${API}/care-dashboard/${subscriberId}`).then(r => {
        setSubName(r.data.subscriber?.name || '');
      }).catch(() => {});
    }
  }, [subscriberId]);

  return (
    <AdminLayout>
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="text-sm text-adm-tertiary text-adm-primary/40 hover:text-slate-700 dark:hover:text-white/70"
            data-testid="back-btn"
          >
            &larr; Back
          </button>
          {subName && (
            <h1 className="text-lg font-['Outfit'] font-bold text-adm-primary text-adm-primary" data-testid="care-dash-header">
              {subName}'s Care Dashboard
            </h1>
          )}
        </div>
        <CareDashboard subscriberId={subscriberId} viewerRole={user?.role} />
      </div>
    </AdminLayout>
  );
}
